import queryString from "query-string";
import { useQuery } from "react-query";
import {
    GetPenyewaResponse,
} from "../../constants/types";
import axios from "../axios";

const handleRequest = async (
    id: number,
) => {
    const apiUrl = queryString.stringifyUrl({
        url: `/api/mruangans-historyComing/${id}`,
    });
    const { data } = await axios.get<GetPenyewaResponse>(apiUrl);
    return data.data;
};

export default function useDetailHistoryRoom(id: number, enabled: boolean) {
    return useQuery<GetPenyewaResponse["data"]>(
        ["detailHistoryComingRoom", id],
        () => handleRequest(id),
        { enabled: !!id && enabled }
    );
}
